export enum MANUFACTURER_STORAGE_KEYS {
  LocationPreference = "manufacturer-location-preference",
  DealerPreference = "manufacturer-dealer-preference",
  PinStatusPreference = "manufacturer-pin-status-preference",
  MechanicFixedPreference = "manufacturer-mechanic-fixed-preference",
  WarrantyPreference = "manufacturer-warranty-preference",
  PinTypePreference = "manufacturer-pin-type-preference",
  AppointmentStatusPreference = "manufacturer-appointment-status-preference-v2",
  QuestionStatusPreference = "manufacturer-question-status-preference",
  RequestStatusPreference = "manufacturer-request-status-preference",
  RegVinPreference = "manufacturer-reg-vin-preference",
  PageSizePreference = "manufacturer-page-size-preference"
}
